import { useEffect } from "react";
import { termsData } from "./helpers";
import "./style.scss";
import SEO from "components/SEO";

function Conditions() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SEO />
      <div className="container">
        <div className="conditions">
          <h1 className="font-title-lg fw-700">Terms & conditions</h1>
          <p className="desc font-body-md2 leading-5 mt-1">
            Effective date: 12 Jan 2025
          </p>

          <div className="terms-container mt-6">
            {termsData.map((section, index) => (
              <div key={index} className="mb-6">
                <h2 className="sub-title font-title-xs fw-700 mb-3">
                  {`${index + 1}. ${section.title}`}
                </h2>

                {/* If section has description */}
                {section.description && (
                  <p className="description font-body-md2 leading-6">
                    {section.description}
                  </p>
                )}

                {/* If section has points */}
                {section.points && (
                  <div className="mt-3">
                    {section.points.map((group, i) => (
                      <div key={i} className="mb-4">
                        {/* Group title (optional) */}
                        {group.title && (
                          <p className="font-title-xs fw-600 mb-2">
                            {group.title}
                          </p>
                        )}

                        <ul className="lists pl-5">
                          {group.points.map((point, j) => (
                            <li
                              key={j}
                              className="list-terms font-title-xs fw-400 mb-1"
                            >
                              {point}
                            </li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default Conditions;
